import { useLiveQuery } from 'dexie-react-hooks';
import { emptySnapshot, type LedgerSnapshot } from '@kemicontrol/domain';
import { useAuth } from '../auth/AuthContext';
import { snapshotForUser } from './db';

export function useLedger(): { userId: string | undefined; snapshot: LedgerSnapshot; loading: boolean } {
  const { user } = useAuth();
  const snapshot = useLiveQuery(() => user ? snapshotForUser(user.id) : undefined, [user?.id]);
  return { userId: user?.id, snapshot: snapshot ?? emptySnapshot(), loading: Boolean(user && !snapshot) };
}
